import { isPlatformBrowser } from '@angular/common';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Actions, ofType, createEffect } from '@ngrx/effects';
import { map, mergeMap, catchError, of } from 'rxjs';

import { Menu } from './permission.state';
import * as PermissionActions from './permission.actions';

interface RoleData {
  role: string | unknown;
  userMenus: Menu[];
  [key: string]: unknown;
}

@Injectable()
export class PermissionEffects {
  actions$ = inject(Actions);
  platformId = inject(PLATFORM_ID);
  http = inject(HttpClient);

  loadUserMenus$ = createEffect(() =>
    this.actions$.pipe(
      ofType(PermissionActions.loadUserMenus),
      mergeMap(() => {
        // Fetch token from local storage
        let token = '';
        if (isPlatformBrowser(this.platformId)) {
          token = localStorage.getItem('token') || '';
        }
        const headers = new HttpHeaders({ 'x-access-token': `Bearer ${token}` });
        const apiUrl = 'mock-data.json';

        return this.http.get<RoleData[]>(apiUrl, { headers }).pipe(
          map((response: RoleData[]) => {
            // Extract data based on roles (e.g., Approver, Super Admin)
            const approverData = response.find((obj: RoleData) => obj.role === 'Approver');
            const menus = approverData ? approverData.userMenus : [];
            return PermissionActions.loadUserMenusSuccess({ menus });
          }),
          catchError((error: unknown) => {
            // console.error('Error loading user menus:', error);
            const errorMessage = error instanceof Error ? error.message : 'Unknown error';
            return of(PermissionActions.loadUserMenusFailure({ error: errorMessage }));
          })
        );
      })
    )
  );
}
